import "../../../css/buttons/PrimaryButton.css";

const PrimaryButton = ({ onClick, text }) => {
  return (
    <button className="primary-button" onClick={onClick}>
      <div className="button-text">{text}</div>
    </button>
  );
};

export default PrimaryButton;
